import React, { FC, memo, type MouseEvent } from 'react';
import equal from 'fast-deep-equal/es6/react';
import { getItemData } from '~/src/components/common-components/dropdown-list/dropdown-list.utils';
import type { DropdownListProps } from '~/src/components/common-components/dropdown-list/dropdown-list.types';
import * as Styled from './dropdown-list.styles';

const DropdownList: FC<DropdownListProps> = ({
    onSuggestHandler,
    options,
    checkIsClickable = () => true,
}) => {
    const onClickHandlerListItem = (value: string | undefined, index: number, event: MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        checkIsClickable(index) && value && onSuggestHandler(value, index);
    };

    return (
        <Styled.ListWindowWrap data-testid="dropdown-list">
            <Styled.ListWindow>
                {options.map((item, index) => {
                    const elem = getItemData(item);
                    return (
                        <Styled.ListItem
                            key={elem.id + index + elem.value}
                            onMouseDown={(event) => onClickHandlerListItem(elem?.value, index, event)}
                            isClickable={checkIsClickable(index)}
                        >
                            {!elem?.isEmpty && <>{elem?.Component && elem?.Component[index] || elem?.value}</>}
                            {elem?.isEmpty && <>{elem?.Component}</>}
                        </Styled.ListItem>
                    );
                })}
            </Styled.ListWindow>
        </Styled.ListWindowWrap>
    );
};

function areEqual(
    { options: prevOptions }: Pick<DropdownListProps, 'options'>,
    { options: nexOptions }: Pick<DropdownListProps, 'options'>) {
    return equal(prevOptions, nexOptions);
}

export const DropdownListMemo = memo(DropdownList, areEqual);
